import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { GlobalIntegrations } from "@/components/portal/GlobalIntegrations";
import PortalLayout from "@/components/portal/PortalLayout";

export const PortalSettings = () => {
  const [activeTab, setActiveTab] = useState("integrations");

  return (
    <PortalLayout>
      <div className="container mx-auto py-6 space-y-6 max-w-5xl">
        <div className="mb-8">
          <h1 className="text-3xl font-bold">Account Settings</h1>
          <p className="text-gray-600">
            Manage your account settings, integrations, and preferences
          </p>
        </div>

      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="space-y-6"
      >
        <TabsList className="grid w-full grid-cols-3 lg:w-auto">
          <TabsTrigger value="integrations">Integrations</TabsTrigger>
          <TabsTrigger value="api">API Keys</TabsTrigger>
          <TabsTrigger value="preferences">Preferences</TabsTrigger>
        </TabsList>

        <TabsContent value="integrations" className="space-y-6">
          <GlobalIntegrations />
        </TabsContent>

        <TabsContent value="api">
          <Card className="p-6">
            <h2 className="text-xl font-semibold mb-4">API Keys</h2>
            <p className="text-gray-600">
              API key management will be available in a future update.
            </p>
          </Card>
        </TabsContent>

        <TabsContent value="preferences">
          <Card className="p-6">
            <h2 className="text-xl font-semibold mb-4">Preferences</h2>
            <p className="text-gray-600">
              Account preferences will be available in a future update.
            </p>
          </Card>
        </TabsContent>
      </Tabs>
      </div>
    </PortalLayout>
  );
};

export default PortalSettings;
